<template>
    <div class="document-list" :class="statusClass">
        <!-- Header -->
        <div class="document-list__header clearfix">
            <table width="100%">
                <thead style="background:none">
                    <tr>
                        <td>
                            <div class="document-list__heading">
                                <span class="document-list__title">{{documentDisplayName}}</span>
                                <template v-if="status === 'default'">
                                    <span class="document-list__status">?</span>
                                </template>
                                <template v-else-if="status === 'rejected' || statusClass == 'document-list--failure'">                                 
                                    <span class="document-list__status" style="font-size: 14px;padding: 0px 6px;color: #d92e42;background: #f9a3ae;">&times;</span>
                                </template>
                                <template v-else-if="status === 'pending' || status === 'initiate'">
                                    <span class="document-list__status" style="color:#F5A623;background: #ffd590;">?</span>
                                </template>
                                <template v-else>                                   
                                    <span class="document-list__status" style="font-size: 10px; padding: 2px 5px; color: #1DC942;">&#10003;</span>
                                </template>
                            </div>
                        </td>
                        <td  style="padding-left:62px;">
                            <span v-if="status != 'archived'" class="document-list__statusHeading">Status</span>
                        </td>
                        <td align="right" style="text-align:right">
                            <!-- <ob-button :disabled="this.consultantDetails.IsEmployeeTerminated" v-if="(status === 'initiate' && documentList.UploadingExistingI9 != true) || (status =='pending' && isEmployeeSigned && documentList.TNCStatus == 'None')" type="primary" style="margin-right:10px;" @click="proceedEverify">Proceed</ob-button>
                            <ob-button :disabled="this.consultantDetails.IsEmployeeTerminated" v-if="status == 'pending' && (documentList.EVerifyStatus == 'DHSTNC' || documentList.EVerifyStatus == 'SSATNC') && documentList.TNCStatus == 'EmployeeContesting' && documentList.IsReferalDateSharedToEmployee == false " @click="shareToEmployee">Share to employee</ob-button>
                            <ob-button :disabled="this.consultantDetails.IsEmployeeTerminated" v-if="status == 'pending' && documentList.IsReferalDateSharedToEmployee" @click="updateEverify">Update</ob-button>
                            <ob-button :disabled="this.consultantDetails.IsEmployeeTerminated" v-if="status == 'rejected'" @click="archiveproceed">Archive I-9</ob-button>
                            <ob-button :disabled="this.consultantDetails.IsEmployeeTerminated" v-if="status === 'initiate' && documentList.UploadingExistingI9 == true" type="primary" @click="proceedEverify">Upload</ob-button> -->

                            <ob-dropdown title="Actions" style="margin-left:10px;" v-if="status == 'validated'">
                                <!-- <ob-dropdown-list-item v-if="status === 'validated' && !consultantDetails.IsEmployeeTerminated" @click.native="populateEverifyPopUp()">Update</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="status != 'archived'" @click.native="printDocument(documentList,'everify')">Print</ob-dropdown-list-item> -->
                                <ob-dropdown-list-item @click.native="viewDocument(documentList,'everify')">Preview</ob-dropdown-list-item>
                                <ob-dropdown-list-item @click.native="downloadDocument(documentList,'everify')">Download</ob-dropdown-list-item>
                            </ob-dropdown>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <span v-if="documentList.UploadingExistingI9 != true">                                
                                <span style="color:#333;font-size:9px;padding-top:5px;display:inline;font-weight:600">Initiated on: <span>{{documentsTableHeader.InitiatedDate |formatDate('MM/DD/YYYY')}}</span></span>
                                <span v-if="status == 'validated'" style="color:#333;font-size:9px;padding-top:5px;display:inline;font-weight:600">| E-Verified on: <span>{{documentsTableHeader.CompletedDate |formatDate('MM/DD/YYYY')}}</span></span>
                            </span>
                            <span v-else>
                                <span v-if="status == 'validated'" style="color:#333;font-size:9px;padding-top:5px;display:inline;font-weight:600">E-Verified on: <span>{{documentsTableHeader.CompletedDate |formatDate('MM/DD/YYYY')}}</span></span>
                            </span>
                        </td>
                        <td style="padding-left: 0px;">
                            <span class="document-list__statusResult status_textup" v-if="status === 'initiate' && documentList.UploadingExistingI9 != true">Initiated</span>
                            <span class="document-list__statusResult status_textup" v-if="status === 'initiate' && documentList.UploadingExistingI9 == true">Not yet uploaded</span>
                            <span class="document-list__statusResult status_textup" v-if="status == 'validated'">Employement Authorised</span>
                            <span class="document-list__statusResult status_textup" v-if="status == 'rejected' && documentsTableHeader.EVerifyStatusData == 'SSADHSFinalNonConfirmation'">SSA/DHS Final Nonconfirmation</span>
                            <span class="document-list__statusResult status_textup" v-if="documentsTableHeader.EVerifyStatusData == 'ReviewAndEmployeeUpdate'">Review and Update</span>
                            <span class="document-list__statusResult status_textup" v-if="status == 'rejected' && documentsTableHeader.EVerifyStatusData == 'EmployeeNoShow'">Employee No-show</span>
                            <span class="document-list__statusResult status_textup" v-if="status == 'rejected' && (documentList.EVerifyStatus == 'DHSTNC' || documentList.EVerifyStatus == 'SSATNC') && documentList.TNCStatus == 'EmployeeNonContesting' ">{{tncStatus}} Non Contesting</span>
                            <span style="padding-bottom: 0;" class="document-list__statusResult status_textup" v-if="status == 'pending' && documentsTableHeader.EVerifyStatusData != 'None' && (documentsTableHeader.EVerifyStatusData == 'DHSTNC' || documentList.EVerifyStatus == 'SSATNC')">{{tncStatus}} Tentative Nonconfirmation</span>

                        </td>
                      <td v-if="status == 'pending' && documentsTableHeader.EVerifyStatusData != 'None' && documentsTableHeader.EVerifyStatusData != 'Employement Authorised'">
                        <span class="document-list__statusResult Waiting_signInitiated" v-if="(documentList.EVerifyStatus == 'DHSTNC' || documentList.EVerifyStatus == 'SSATNC') && !isEmployeeSigned">Waiting for the employee to sign</span>
                      </td>
                    </tr>
                </tbody>
              <tbody>
                <tr>
                  <td>
                  </td>
                  <td style="padding-left: 62px;" v-if="status != 'initiate' && status != 'archived'">
                    <span class="case-closed_text" v-if="status == 'validated' || status === 'rejected' ">Case Closed</span>
                    <span class="case-days_text" v-if="status == 'pending' && documentsTableHeader.EVerifyStatusData != 'ReviewAndEmployeeUpdate'">You have to submit on or before <b>{{documentList.TNCSubmissionEndDate | formatDate('MM/DD/YYYY')}}</b></span>
                    
                    
                  </td>
                  
                </tr>
              </tbody>
            </table>
        </div>

        <!-- <div class="i9-document-list-alerts" v-if="anyDocumentListAlerts">
            <i9-document-list-alerts v-for="(alertItem,index) in i9DocListAlerts" :alert="alertItem" :key="index">

            </i9-document-list-alerts>
        </div> -->

        <!-- Body -->
        <div class="document-list__body" v-if="documentsTableData && documentsTableData.length > 0">
            <div class="document-list__uploadedSection">
                <div class="document-list__uploadedDocs" v-for="(d, dIndex) in documentsTableData" :key="dIndex">
                    <span class="document-list__title text_Namefol" >{{d.DocumentUrl | URL2FileName}}</span>
                    <!--<img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/Content/Images/docs_down_arrow.jpg`"/>-->
                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                        <div class="popper" style="padding:0px">
                            <div class="document-popover" style="background:#f1f1f1">
                                <div style="padding:10px;display:inline-block;">
                                    <p>Issue Date</p>
                                    <p>{{d.IssueDate | formatDate('MM/DD/YYYY')}}</p>
                                </div>
                                <div style="padding:10px;display:inline-block">
                                    <p>Expiry Date</p>
                                    <p>{{d.ExpiryDate | formatDate('MM/DD/YYYY') }}</p>
                                </div>
                            </div>
                            <div style="padding:10px;">
                                <!-- <span style="display:inline-block;padding-right:10px"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(d.DocumentUrl)"/></span> -->
                                <span style="display:inline-block;padding:0 5px"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="32" height="32" @click="downloadSingleDoc(d.DocumentUrl)"/></span>
                                <span style="display:inline-block;padding-left:10px"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(d.DocumentUrl)"/></span>
                            </div>
                        </div>

                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-top:-7px;"/>

                    </ob-popover>                 
                </div>
            </div>


        </div>



    </div>
</template>
<script>
   // import I9CommonFunctionMixin from '../I9DocumentListMixin.js'
//    import I9DocumentListAlerts from '../I9DocumentListAlerts.vue'
    import c from '@/components/Core/constants.js'
    import utils from '@/components/Core/utils.js'
    export default {
        name: 'ob-vdoc-list',
        //mixins: [I9CommonFunctionMixin],
        props: {
            documentList: {
                type: Object,
                required: true
            },
            documentDisplayName: {
                type: String,
                required:true
            },
            completeI9Details: {
                type: Object
            },
        },

        data() {
            return {
                doValidation: false,
                isFormValid: false,
                isUploading: false,
                show: false,
                oldFieldValues: {},
                fieldValues: {},
                modalType: "",
                dateTimeKeys: [
                    "IssueDate",
                    "ExpiryDate",
                    "PODate",
                    "I94StartDate",
                    "I94EndDate",
                    "SignedDate",
                    "CertifiedDate",
                ],
                IsEverifyUpdate : false,
                i9DocListAlerts: []
            }
        },
        components: {
            //'i9-document-list-alerts' : I9DocumentListAlerts
        },
        computed: {            
            status() {
                if(this.documentsTableHeader.Status != '' && this.documentsTableHeader.Status != null){
                    return this.documentsTableHeader.Status.toLowerCase()
                }else{
                    return ''
                }
            },
            consultantDetails() {
               return this.$store.getters.getConsultantDetails
             },
            documentsTableHeader() {
                let docHeader = {}
                if(this.documentList.InitiatedOn !='0001/01/01T00:00:00')
                {
                docHeader.InitiatedDate = this.documentList.InitiatedOn
                }else{
                docHeader.InitiatedDate = this.documentList.CreatedDateTime
                }
                docHeader.CompletedDate = this.getEmploymentAuthorizedDate()
                docHeader.EVerifyStatusData = this.documentList.EVerifyStatus
                if (this.documentList.Status != undefined)
                    docHeader.Status = this.documentList.Status
                else
                    docHeader.Status = this.documentList.DocumentStatus

                return docHeader
            },
            documentsTableData() {

                let documentsTableData = [];

                if (this.documentList.DocumentList != undefined) {
                    this.documentList.DocumentList.forEach((td) => {
                        if (td.DocType != 'DHSEmploymentAuthorization' && td.DocumentUrl != ''){
                        let doc = {}
                        doc.IssueDate = td.IssueDate
                        doc.ExpiryDate = td.ExpiryDate
                        doc.DocumentUrl = td.DocumentUrl
                        doc.DocumentId = td.Id

                        documentsTableData.push(doc)
                      }
                    })
                }
                return documentsTableData
            },
            statusClass() {
                if (this.status === 'default') {
                    return 'document-list--default'
                } else if (this.status === 'success' || this.status == 'validated') {
                    return 'document-list--success'
                } else if (this.status === 'rejected'){
                    return 'document-list--failure'
                } else if (this.status == 'archived') {
                    if ((this.documentList.EVerifyStatus == 'DHSTNC' || this.documentList.EVerifyStatus == 'SSATNC') && this.documentList.TNCStatus != 'None')
                        return 'document-list--failure'
                    else
                        return 'document-list--success'
                }
                else if (this.status == 'pending' || this.status == 'initiate') {
                    return 'document-list--pending'
                }
            },
            everifyStatus() {
                if (this.status == 'pending') {
                    if (this.documentList.EVerifyStatus == 'DHSTNC' || this.documentList.EVerifyStatus == 'SSATNC')
                        return 'Tnc'
                    else
                        return 'General'
                }
                else
                    return 'General'
            },
            tncStatus() {
                if (this.status == 'rejected') {
                    if (this.documentList.EVerifyStatus == 'DHSTNC')
                        return 'DHS-TNC'
                    else if (this.documentList.EVerifyStatus == 'SSATNC')
                        return 'SSA-TNC'
                }
                else if (this.status == 'pending') {
                    if (this.documentList.EVerifyStatus == 'DHSTNC')
                        return 'DHS'
                    else if (this.documentList.EVerifyStatus == 'SSATNC')
                        return 'SSA'
                }
            },
            isEmployeeSigned() {
                let bool =  false
                if (this.documentList.EVerifyStatus == 'DHSTNC' || this.documentList.EVerifyStatus == 'SSATNC') {
                    if (this.documentList.DocumentList.length > 0 && this.documentList.DocumentList[0].Signer.length > 0) {
                        this.documentList.DocumentList[0].Signer.some((a) => {
                            if (a.SignatureStatus == 'Completed') {
                                 bool = true                                
                            }
                            else {
                                bool = false   
                                return true
                            }
                                
                        })
                    }                   
                }
                return bool                
            },
            anyDocumentListAlerts(){
                let everifyAlerts = [];
                if(this.documentList != null && this.documentList.DocumentStatus != null && this.documentList.DocumentStatus == 'Initiate'){
                    everifyAlerts.push(`Please upload the candidate's E-Verify document`)
                }
                this.i9DocListAlerts = everifyAlerts;
                if(everifyAlerts.length > 0)
                    return true;
                else 
                    return false;
            }
        },
        methods: {
            getEmploymentAuthorizedDate(){
                let everifiedDate 
                if (this.documentList.DocumentList != undefined) {
                    this.documentList.DocumentList.forEach((document) => {
                        if (document.DocType == 'DHSEmploymentAuthorization' && document.DocumentUrl != ''){
                        everifiedDate = document.IssueDate
                        }
                    })
                }
                return everifiedDate
            } ,
            proceedEverify() {
                if (this.status == 'initiate')
                {
                    let everifyObj = {
                        'Status' : this.everifyStatus,
                        'IsEverifyUpdate' : this.IsEverifyUpdate
                    }
                    events.fire('proceedToEverify', everifyObj)

                } else {
                    if (this.status == 'pending' && (this.documentList.EVerifyStatus == 'DHSTNC' || this.documentList.EVerifyStatus == 'SSATNC')) {
                        this.$emit('employeeContesting')
                    }
                }
            },
            shareToEmployee() {
                events.fire('shareToEmployee')
            },
            updateEverify() {
                let everifyObj = {
                    'Status' : this.everifyStatus,
                    'IsEverifyUpdate' : this.IsEverifyUpdate
                }
                events.fire('proceedToEverify', everifyObj)
            },
            populateEverifyPopUp(){
                this.IsEverifyUpdate = true
                let everifyObj = {
                    'Status' : this.everifyStatus,
                    'IsEverifyUpdate' : this.IsEverifyUpdate
                }
                events.fire('proceedToEverify', everifyObj)
            },
            archiveproceed(){
               this.$loading({ 'loadingText': 'Loading...' })
               ajax.put(`/I9/ArchiveI9?consultantId=${this.consultantDetails.Id}&status=Archived`, {} , (res) => {
                   this.$store.dispatch('getI9Details', { 'consultantId': this.consultantDetails.Id, 'bool': true }).then(() => {
                            this.$loading({}).close()
                        }).i9
               
              })
            
            },


     viewDocument(doc, section) {
                    if (section == 'everify') {
                        let url
                        doc.DocumentList.forEach((d) => {
                            if (d.DocType == 'DHSEmploymentAuthorization')
                                url = d.DocumentUrl;
                        })
                        utils.previewSingleDoc(url)
                        //window.open(url, '_blank')
                        //window.open(utils.getFilePreviewLink(url), '_blank')
                    }
                    
            },    
            
            
            downloadDocument(doc, section) {
                            
                if (section == 'everify') {
                    let url
                    doc.DocumentList.forEach((d) => {
                        if (d.DocType == 'DHSEmploymentAuthorization')
                            url = d.DocumentUrl;
                    })
                    utils.downloadSingleDoc(url)
                    //window.open(url, '_blank');
                }
                
            },   
            
            downloadSingleDoc(doc) {
                utils.downloadSingleDoc(doc)
                //let d = doc + "&download=true";
                //window.open(d, '_blank')
            },            
            previewSingleDoc(doc) {
                utils.previewSingleDoc(doc)   
                //window.open(doc,'_blank')
                //window.open(utils.getFilePreviewLink(doc),'_blank')
            },            

        }
    }
</script>

<style lang="scss" scoped>

    @import "~styles/framework/vue-utils";

    @import "~styles/framework/bootstrap/progress-bars";

    $default-border-color : #c2c2c2; $default-background-color: #fdfdfd; $success-border-color : #a4f3b5; $success-background-color: #f4fef7; .document-list {
        border-top: 1px dashed #ccc;
        padding: 15px 10px 15px 0;       
    }

    .document-list__header {
        position: relative;
        z-index: 1;
        table{
             thead{
            td{
                  width:33.33%;
                  .document-list__statusHeading{
                    font-weight:500;
                    color:#333;
                    padding-top:7px;
                    font-size: 13px;
                    display:block;
                }
               }
              }
              tbody{
                    td{
                  padding:0px 0 0px 4px;
                  .document-list__statusResult{
                      padding:5px;
                      display:block;
                       padding-left:62px;
                       font-weight:600;
                       font-size:10.5px;
                  }                
                }
             }
        }
    }
    .document-list__title {
        padding-right: 10px;
    }
    .text_Namefol {
        padding-top: 2px;
        display: inline-block;
        width: 200px;
    }
    .document-list__uploadedDocs {
        padding: 3px 10px;
        border: 1px solid #5597e3;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: #e6eff9;
        margin: 5px 5px 5px 0px;
        .document-popover{
            background:#f1f1f1;
            p{
                margin:0px;
                color:#333;
                font-weight:600;
             }
             img{
                 cursor:pointer;
             }
        }
    }

    .i9-document-list-alerts{
        padding: 2px 0px;
    }

    .document-list__heading {
        padding: 5px 10px;
        border: 1px solid $default-border-color;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: $default-background-color;
        float: left;
    }

    .document-list__status {
        background: $default-border-color;
        color: $default-background-color;
        padding: 0px 5px;
        border-radius: 100%;
    }

    .document-list__controls {
        float: right;
    }

    .document-list.document-list--success {
        .document-list__heading{
            border: 1px solid #1DC942;
            background: $success-background-color;
        }

        .document-list__status {
            background: $success-border-color;
            color: #1DC942;
        }
        .document-list__statusResult {
            color: #1DC942;
        }
    }
    .document-list.document-list--failure {
         .document-list__heading{
            border: 1px solid #d92e42;
            background: #ffdadf;
         }
        .document-list__statusResult{
            color:#d92e42;
        }
    }

    .document-list.document-list--pending {
        .document-list__heading{
            border: 1px solid #F5A623;
            background: #FFEED2;
         }
        .document-list__statusResult {
            color: #F5A623;
        }
    }
    .document-list__body {
        position: relative;
        /*top: -18px;*/
        .document-list__uploadedSection{
             padding:5px 0px 0px;
                .document-list__status{
                    font-size: 11px;
                    color: #5597e3;
                    background: #bcd8f8;
                    padding: 1px 6px;
                    margin-left: 5px;
            }
        }
    }

    .progress {
        overflow: hidden;
        height: 5px;
        margin-bottom: 0;
        background-color: #f5f5f5;
        border-radius: 10px;
        -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    }

    .upload_div, .upload_file_div {
        padding: 35px;
        background: #FAFEFF;
        border: 2px dashed #ccc;
        border-radius: 8px;
        display: table;
        width: 100%;
        cursor: pointer;
        text-align: center;
        &.dragover

    {
        background: #fff;
    }

    }

    .upload_file_div {
        padding: 15px;
        cursor: default;
    }

    .upload-inner {
        display: table-cell;
        vertical-align: middle;
        padding: 15px;
        width: 15%;
    }

    .width-70 {
        width: 70%;
    }

    .margin-top-25 {
        margin-top: 25px;
    }

    .upload_img {
        padding: 15px 0 20px 0;
    }

    .upload_text {
        padding: 0 0 20px 0;
    }

    .icon {
        width: 50px;
    }

    .icon1 {
        width: 35px;
    }

    .info {
        margin: 0;
        font-size: 13px;
        line-height: 18px;
        color: #999;
        display: inline-block;
    }

    .file_name_span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 600px;
        display: inline-block;
    }


    /* Error */
    .error-holder {
        margin: 10px 0;
    }

    .error-msg {
        color: $ob-error-red;
    }


    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }


    /* Signers list */
    .signature-holder {
        .document-signer

    {
        font-size: 16px;
        font-weight: 600;
        color: #337AB5;
    }

    .signauture-success {
        font-size: 9px;
        color: #FFFFFF;
        background: #3CB55B !important;
    }

    .signauture-pending {
        font-size: 9px;
        color: #FFFFFF;
        background: #008BE7 !important;
    }

    .document-signature-details {
        font-size: 14px;
        color: #2A2A2A;
    }
    }
    .case-closed_text{
      color: #9a94a7;
      font-size: 9px;
      font-weight: 600;
      transform: translatey(-5px);
      display: block;
    }
    .status_textup{
      transform: translatey(-5px);
    }
    .case-days_text {
    color: #333;
    font-size: 9px;
    font-weight: 600;
    -webkit-transform: translatey(-5px);
    transform: translatey(-5px);
    display: block;
}
    .Waiting_signInitiated {
    font-size: 10.5px;
    padding-right: 0;
    text-align: right;
    }
      .document-list.document-list--H1b-transfer {
        .document-list__heading{
            border: 1px solid #F5A623;
            background: #FFEED2;
         }
        .document-list__statusResult {
            color: #1DC942;
        }
    }
</style>


<style lang="scss">

    /* animation duration and fill mode */
    .animation {
        animation-duration: 1s;
        animation-fill-mode: both;
        display: inline-block;
    }

    /* bounceOutLeft animation declaration & iteration counting */
    .bounceOutLeft {
        animation-name: bounceOutLeft
    }

    /* bounceOutLeft animation keyframes */
    @keyframes bounceOutLeft {
        18% {
            transform: translate3d(27px, 0, 0)
        }

        33% {
            transform: translate3d(-12px, 0, 0)
        }

        48% {
            transform: translate3d(8px, 0, 0)
        }

        100% {
            transform: translate3d(-300%, 0, 0)
        }
    }

    @keyframes bounceInUp {
        0% {
            opacity: 0;
            -webkit-transform: translateY(2000px);
            -ms-transform: translateY(2000px);
            transform: translateY(2000px);
        }

        60% {
            opacity: 1;
            -webkit-transform: translateY(-30px);
            -ms-transform: translateY(-30px);
            transform: translateY(-30px);
        }

        80% {
            -webkit-transform: translateY(10px);
            -ms-transform: translateY(10px);
            transform: translateY(10px);
        }

        100% {
            -webkit-transform: translateY(0);
            -ms-transform: translateY(0);
            transform: translateY(0);
        }
    }

    .bounceOuttop {
        animation-name: bounceInUp
    }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/ESSComponents/I9EverifyDocList/I9VDocList.vue